import { Link, useParams } from 'react-router-dom';
import { useUiStore } from '../../store';
import { STRINGS } from '../../i18n';
import { getToolBySlug } from '../../data/tools';
import { trackEvent } from '../../lib/analytics';

export function ToolPage() {
  const { slug } = useParams<{ slug: string }>();
  const locale = useUiStore((s) => s.locale);
  const t = STRINGS[locale];
  const tool = slug ? getToolBySlug(slug) : undefined;

  if (tool) {
    trackEvent('tool_open', { slug: tool.slug, tier: tool.tier, category: tool.category });
  }

  if (!tool) {
    return (
      <main className="px-6 py-24">
        <div className="mx-auto max-w-xl text-center">
          <h1 className="text-3xl font-semibold text-slate-900">404</h1>
          <p className="mt-3 text-slate-500">This tool does not exist (yet).</p>
          <Link
            to="/"
            className="mt-6 inline-block rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          >
            {t.backHome}
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="px-6 py-20">
      <div className="mx-auto max-w-3xl">
        <p className="text-sm uppercase tracking-wide text-brand-600">
          {tool.category} - {tool.tier}
        </p>
        <h1 className="mt-2 text-4xl font-bold text-slate-900">
          {tool.name}
        </h1>
        <p className="mt-3 text-lg text-slate-500">{tool.tagline}</p>

        <div className="mt-10 rounded-xl border border-slate-200 bg-white p-8 text-center">
          <p className="text-sm uppercase tracking-wide text-slate-400">
            Coming soon
          </p>
          <p className="mt-2 text-xl font-medium text-slate-900">
            {t.toolComingSoon(tool.name)}
          </p>
          <Link
            to="/"
            className="mt-6 inline-block rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            {t.backHome}
          </Link>
        </div>
      </div>
    </main>
  );
}

export default ToolPage;
